/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { VApplication } from '../../../../application';
import { toHeaderCase } from 'js-convert-case';
import config from '../config/preview.config.json';

export interface IFormatPreviewDetailMethods extends IPluginMethodMap {
  getFormatPreviewDetailSync(args: any): any;
}

export class FormatPreviewDetailService implements IAgentPlugin {
  readonly methods: IFormatPreviewDetailMethods;

  constructor() {
    this.methods = {
      getFormatPreviewDetailSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      ...config,
      listItems: this.getListItems(args?.formData),
      accordionItems: this.getAccordionItems(args),
      badgeCarouselItems: this.getBadgeCarousel(args),
      carouselItems: this.getCarouselItems(args),
    };
  }

  private getAccordionItems(res: any) {
    let items: any = [];
    console.log(`compList`, res?.compData);
    console.log(`orgList::`, res?.orgList);
    if (res?.formData) {
      let _temp = this.getListData(res?.formData);
      items.push({
        type: 'multi-col-list',
        numberOfColumns: '2',
        title: config?.stepTitle,
        data: [..._temp],
      });
    }
    if (res?.orgList && Array.isArray(res?.orgList)) {
      let _data: string[] = [];
      res?.orgList.forEach((element) => {
        _data.push(element?.appCardTitle);
      });
      items.push({
        type: 'check-list',
        title: config?.orgListTitle,
        data: [..._data],
      });
    }
    return items;
  }

  private getListData(obj: any) {
    let _temp: any = [];
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string') {
        _temp.push({
          title: toHeaderCase(key),
          subTitle: value,
        });
      }
    }
    return _temp;
  }

  private getListItems(data: any) {
    let _temp: any = [];
    for (const [key, value] of Object.entries(data)) {
      if (key === 'batchNo') {
        _temp.push({
          icon: 'https://i.ibb.co/5xbNYds/files.png',
          key: key,
          title: toHeaderCase(key ?? ''),
          subTitle: value,
        });
      }
      if (key === 'batchDate') {
        _temp.push({
          icon: 'https://i.ibb.co/R7mZS7m/date.png',
          key: key,
          title: toHeaderCase(key ?? ''),
          subTitle: value,
        });
      }
      if (key === 'batchLocation') {
        _temp.push({
          key: key,
          icon: 'https://i.ibb.co/tZTJ1TG/location.png',
          title: toHeaderCase(key ?? ''),
          subTitle: value,
        });
      }
      if (key === 'plantedOn') {
        _temp.push({
          key: key,
          icon: 'https://i.ibb.co/R7mZS7m/date.png',
          title: toHeaderCase(key ?? ''),
          subTitle: value,
        });
      }
      if (key === 'harvestedOn') {
        _temp.push({
          key: key,
          icon: 'https://i.ibb.co/R7mZS7m/date.png',
          title: toHeaderCase(key ?? ''),
          subTitle: value,
        });
      }
    }
    return _temp;
  }

  private getBadgeCarousel(data: any) {
    let _temp: any = [];
    if (data?.compData) {
      for (const [key, value] of Object.entries(data?.compData)) {
        if (Array.isArray(value) && value?.length > 0) {
          value.forEach((element) => {
            if (element?.type) {
              _temp.push({
                title: toHeaderCase(this.removeExtension(element?.name) ?? ''),
                titleImage: element?.base64,
              });
            }
          });
        }
      }
    }
    return _temp;
  }

  private getCarouselItems(data: any) {
    let _temp: any = [];
    if (data?.formData) {
      for (const [key, value] of Object.entries(data?.formData)) {
        if (Array.isArray(value) && value?.length > 0) {
          value.forEach((element) => {
            if (element?.type) {
              _temp.push({
                type: 'img',
                src: element?.base64,
                poster: element?.base64,
                title: toHeaderCase(this.removeExtension(element?.name) ?? ''),
              });
            }
          });
        }
      }
    }
    return _temp;
  }

  private removeExtension(filename: string) {
    return filename.substring(0, filename.lastIndexOf('.')) || filename;
  }
}
